import graphql__be829a8e2492a4510837 from "./__generated__/UpdateCommentMutation.graphql.js";import { commitMutation, graphql } from "react-relay";

import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__be829a8e2492a4510837;

function updateComment(commentId, content, onCompleted) {
  const variables = {
    commentId,
    content
  };

  return commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted,
    onError: error => console.error(error)
  });
}

export { updateComment };
